import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class BannerService {

    public Coupondata: any;

    constructor(private httpService: HttpService) { }

    addBanner(data: any,file:any): Observable<any> {
        const allData = new FormData();

        for(let i=0;i<file.length;i++)
        allData.append('banner[]',file[i]);
        allData.append('title',data.title);

        const url = `${environment.SettingsApiendpoint }/image-upload`
        return this.httpService.post(url, allData, this.httpService.headers)

    }


    changeBannerStatus(id:any,data: any): Observable<any> {
        // const allData = new FormData();

        // allData.append({'status':data});

      const url = `${environment.SettingsApiendpoint }/image-statuschange/${id}`
      return this.httpService.put(url, data, this.httpService.headers)
  }

    deleteBanner(id: any) {
        const url = `${environment.SettingsApiendpoint}/image-delete/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    bannersList(search: any) {
        const url = `${environment.SettingsApiendpoint}/image-view?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }






    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
            console.error(err.error.message);
        } else {
            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }
}
